<app-header></app-header>
<div class="page-container uk-container uk-container-expand" uk-height-viewport="offset-top: true; offset-bottom: true">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>

<loading></loading>